<template>
    <div class="cat-code-editor">
        <span v-if="modifiable">
            <span class="label prefix">{{ fixedPart }}</span><el-input class="input" size="mini" v-model="inputPart" @change="handleInput" clearable :title="errorHint"></el-input>
        </span>
        <span v-else class="label">{{ code }}</span>
    </div>
</template>
<script>
    import {Jqext, Utils} from '../../app.base'

    let Toast = Jqext.Toast;


    function isNumericStr(str) {
        var pattern = /^[0-9]+$/;
        return pattern.test(str);
    }

    function genCodeCustRule(custCodeLevelLens) {
        let ruleNums = [];
        for (let i = 0, c = custCodeLevelLens.length; i < c; i++) {
            ruleNums[i] = '9'.duplicate(custCodeLevelLens[i]);
        }
        return ruleNums.join('/');
    }

    function splitCodeParts(code, parentCode, prefix) {
        code = code || '';
        let fixedPart = parentCode || prefix;
        let inputPart = '';
        if (code !== '') {
            if (code.startsWith(fixedPart)) {
                inputPart = code.substring(fixedPart.length);
            } else {
                fixedPart = prefix;
                if (code.length >= fixedPart.length) {
                    inputPart = code.substring(fixedPart.length);
                } else {
                    inputPart = code;
                }
            }
        }

        return {
            fixedPart: fixedPart,
            inputPart: inputPart
        };
    }


    export default {
        name: 'swb-cat-code-editor',
        desc: '分类编码编辑器',
        props: {
            // 新增：C reate, 查看：V iew, 修改：M odify
            crud: {
                type: String,
                default: 'V'
            },
            // maxCodeLength, maxLevelCount,
            // custPrefix[, custPrefixLen], custCodeRule[, custLevelCount, custCodeLevelLens， custCodeLength, codeModifiable]
            conf: {
                type: Object,
                default: function () {
                    return {
                        // meta --------------=
                        //最大编码长度
                        maxCodeLength: 18,
                        //最大编码级数
                        maxLevelCount: 4,
                        // cust ---------------
                        //自定义前缀（比如：WLFL）
                        custPrefix: '', // 计算得到=> custPrefixLen
                        //自定义编码规则（形如：2/3/3/4）
                        custCodeRule: '',
                        //自定义编码级数
                        custLevelCount: 0,
                        //自定义编码各级位数（或者是 custCodeLenL1, custCodeLenL2, custCodeLenL3, custCodeLenL4）
                        custCodeLevelLens: [], // + custPrefixLen 计算得到=> custCodeLength
                        //编码是否可以修改
                        codeModifiable: false
                    };
                }
            },
            //父级编码
            parentCode: {
                type: String,
                default: ''
            },
            //编码级别
            codeLevel: {
                type: Number,
                default: 1
            },
            //当前编码
            code: {
                type: String,
                default: ''
            },
            //输入部分是否仅允许数字
            digitsOnly: {
                type: Boolean,
                default: true
            }
        },
        //
        data: function () {
            return {
                config: {
                    // meta --------------=
                    //最大编码长度
                    maxCodeLength: 18,
                    //最大编码级数
                    maxLevelCount: 4,
                    // cust ---------------
                    //自定义前缀（比如：WLFL）
                    custPrefix: '', // 计算得到=> custPrefixLen
                    //自定义编码规则（形如：2/3/3/4）
                    custCodeRule: '',
                    //自定义编码级数
                    custLevelCount: 0,
                    //自定义编码各级位数（或者是 custCodeLenL1, custCodeLenL2, custCodeLenL3, custCodeLenL4）
                    custCodeLevelLens: [], // + custPrefixLen 计算得到=> custCodeLength
                    //编码是否可以修改
                    codeModifiable: false
                },
                //固定部分
                fixedPart: '',
                //输入部分
                inputPart: '',
                //当前级别最大长度
                levelMaxLength: 0,
                //输入部分最大长度
                inputMaxLength: 0,
                modifiable: false,
                //
                errorHint: ''
            };
        },
        watch: {
            crud(newVal, oldVal) {
                console.log('crud --- changed');
                this.init();
            },

            conf(newVal, oldVal) {
                console.log('conf --- changed');
                this.init();
            },
            parentCode(newVal, oldVal) {
                console.log('parentCode --- changed');
                this.init();
            },
            codeLevel(newVal, oldVal) {
                console.log('codeLevel --- changed');
                this.init();
            },
            code(newVal, oldVal) {
                console.log('code --- changed');
                this.init();
            }
        },
        mounted() {
            this.init();
        },
        beforeDestroy() {

        },
        //
        methods: {
            init() {
                //取当前配置
                let config = Utils.merge(this.config);
                //融合新配置
                config = Utils.merge(config, this.conf);
                config.custPrefix = config.custPrefix || '';
                config.custPrefixLen = config.custPrefix.length;
                let custCodeLevelLens = config.custCodeLevelLens || [];
                if (custCodeLevelLens === 0) {
                    if (Utils.isInt(config.custCodeLenL1) && config.custCodeLenL1 > 0) {
                        custCodeLevelLens.push(config.custCodeLenL1);
                        if (Utils.isInt(config.custCodeLenL2) && config.custCodeLenL2 > 0) {
                            custCodeLevelLens.push(config.custCodeLenL2);
                            if (Utils.isInt(config.custCodeLenL3) && config.custCodeLenL3 > 0) {
                                custCodeLevelLens.push(config.custCodeLenL3);
                                if (Utils.isInt(config.custCodeLenL4) && config.custCodeLenL4 > 0) {
                                    custCodeLevelLens.push(config.custCodeLenL4);
                                    if (Utils.isInt(config.custCodeLenL5) && config.custCodeLenL5 > 0) {
                                        custCodeLevelLens.push(config.custCodeLenL5);
                                    }
                                }
                            }
                        }
                    }
                }
                config.custCodeLevelLens = custCodeLevelLens;
                config.custLevelCount = custCodeLevelLens.length;
                config.custCodeRule = config.custCodeRule || genCodeCustRule(custCodeLevelLens);
                config.custCodeLength = config.custPrefixLen + custCodeLevelLens.sum();
                //console.log(config);
                this.config = config;
                //
                let levelLengs = config.custCodeLevelLens.slice(0, this.codeLevel);
                this.levelMaxLength = config.custPrefixLen + levelLengs.sum();
                //
                let parentCode = this.codeLevel === 1 ? '' : this.parentCode || '';
                let code = this.code || '';
                if (this.crud === 'C') {
                    code = '';
                    this.modifiable = true;
                    //
                    let parts = splitCodeParts(code, parentCode, config.custPrefix);
                    this.fixedPart = parts.fixedPart;
                    this.inputPart = parts.inputPart;
                } else if (this.crud === 'M') {
                    this.modifiable = config.codeModifiable || false;
                    if (this.modifiable) {
                        let parts = splitCodeParts(code, parentCode, config.custPrefix);
                        this.fixedPart = parts.fixedPart;
                        this.inputPart = parts.inputPart;
                    }
                } else {
                    this.modifiable = false;
                }
                //
                this.inputMaxLength = this.levelMaxLength - this.fixedPart.length;
                console.log(this.inputMaxLength);
                if (this.inputMaxLength < 0) {
                    this.inputMaxLength = 0;
                }
                //
                this.errorHint = '字符数：' + this.inputMaxLength;
                //
                this.handleInput();
            },
            handleInput() {
                this.inputPart = (this.inputPart || '').trim();
                if (this.inputPart.length < this.inputMaxLength) {//自动补0
                    this.inputPart = this.inputPart.padLeft(this.inputMaxLength, '0');

                } else if (this.inputPart.length > this.inputMaxLength) {//自动截断
                    this.inputPart = this.inputPart.substring(0, this.inputMaxLength);
                }
            },
            //
            validate() {
                if (this.modifiable) {
                    this.inputPart = (this.inputPart || '').trim();
                    if (this.inputPart.length !== this.inputMaxLength) {
                        return '可编辑部分的字符数必须是：' + this.inputMaxLength;
                    }
                    //
                    if (this.digitsOnly && !isNumericStr(this.inputPart, 0)) {
                        return '可编辑部分的字符只能是数字（0-9）';
                    }
                }
                //
                return '';
            },
            getResult() {
                let result = {
                    type: 'info',
                    data: null
                };
                if (this.modifiable) {
                    let errMsg = this.validate();
                    if (errMsg) {
                        result.type = 'error';
                        result.message = errMsg;
                        //
                        return result;
                    }
                }
                let code = this.code;
                if (this.modifiable) {
                    code = this.fixedPart + this.inputPart;
                }
                result.data = code;
                //
                return result;
            }

        }
    }
</script>

<style>
    .cat-code-editor {
        display: inline-block;
    }

    .cat-code-editor .label {
        display: inline-block;
        height: 26px;
        padding-top: 4px;
    }

    .cat-code-editor .label.prefix {
        margin-right: 2px;
    }

    .cat-code-editor .input {
        width: 140px;
    }

</style>



// WEBPACK FOOTER //
// src/compo/comn/CatCodeEditor.vue